import React from 'react'

class NexcessHeader extends React.Component {
	render() {
		return <div className="lw">
			<div className="navbar">
				<div className="navbar-inner">
					<img className="liquidweb-logo" src="/assets/liquidweb-logo.png" alt="Nexcess"/>
					<img className="blogvault-logo" src="/assets/powered-by-blogvault-logo.png" alt="Powered by BlogVault"/>
				</div>
			</div>
		</div>
	}
}

export default NexcessHeader
